<template>
  <div class="bb-fund-settings">
    <div class="bb-form">
      <div class="bb-form-item">
        <label class="bb-fund-settings__label bb-form__label" for="fund">
          Funds
        </label>
        <input class="bb-input bb-input_border bb-fund-settings__input"
               :class="{'bb-input_error': invalidName}"
               type="text"
               id="fund"
               v-autofocus
               ref="inputName"
               v-model="fund.name"
               @keyup.enter="setSettings"
               @input="invalidName = false">
      </div>
      <div class="bb-fund-settings-bottom">
        <div class="bb-fund-settings-bottom-item">
          <label class="bb-fund-settings-bottom-item__label bb-form__label">
            Priority
          </label>
          <toggle @toggleChange="toggleChange"
                  type="accent"
                  :value="fund.priority"/>
        </div>
        <div class="bb-fund-settings-bottom-item">
          <label class="bb-fund-settings-bottom-item__label bb-form__label" for="percent">
            Percent
          </label>
          <div class="bb-fund-settings-bottom-item__input-wrapper">
            <input class="bb-input bb-input_border bb-fund-settings-bottom-item__input"
                   :class="{'bb-input_error': invalidPercent}"
                   type="text"
                   id="percent"
                   autocomplete="off"
                   ref="inputPercent"
                   @input="changePercent"
                   v-model="fund.percent"
                   @keyup.enter="setSettings">
            <span v-if="errorPercent" class="bb-fund-settings-bottom-item__error">{{errorPercent}}</span>
          </div>
          <i class="icon-percent bb-fund-settings-bottom-item__icon"/>
        </div>
        <div class="bb-fund-settings-bottom-item">
          <label class="bb-fund-settings-bottom-item__label bb-form__label" for="balance">
            Start balance, AED
          </label>
          <input class="bb-input bb-input_border bb-fund-settings-bottom-item__balance"
                 :class="{'bb-input_error': invalidAmount}"
                 type="text"
                 id="balance"
                 ref="inputAmount"
                 autocomplete="off"
                 @focus="focusInput()"
                 @keyup.enter="setSettings"
                 @input="invalidAmount = false"
                 v-model="fund.lastMonthBalance">
        </div>
      </div>
    </div>
    <div @click="setSettings" class="bb-fund-settings__button">
      <slot/>
    </div>
  </div>
</template>

<script>
import toggle from '@/components/Main/Inputs/toggle'
import convertNumber from '@/mixin/convertNumber'
import validateNum from '@/mixin/validateNum'
import _ from 'lodash'

export default {
  name: 'FundSettingsWindow',
  props: ['editFund'],
  mixins: [convertNumber, validateNum],
  components: {
    toggle
  },
  data () {
    return {
      errorPercent: false,
      invalidName: false,
      invalidAmount: false,
      invalidPercent: false,
      fund: {
        name: '',
        priority: false,
        percent: 0,
        lastMonthBalance: 0
      }
    }
  },
  computed: {
    fundsList () {
      return this.$store.getters.fundsRowsData
    }
  },
  methods: {
    changePercent (e) {
      const value = e.target.value
      if (typeof this.fund.percent === 'string' && value) {
        this.fund.percent = this.validateNum(this.fund.percent)
      }
      this.invalidPercent = false
    },
    toggleChange (data) {
      if (data === 'hide') {
        return
      }
      this.fund.priority = data
    },
    focusInput () {
      if (!this.validateNum(this.fund.lastMonthBalance)) {
        this.fund.lastMonthBalance = ''
      }
    },
    checkPercent () {
      let sumPercent = this.fundsList.reduce((sum, value) => {
        return sum + value.percent
      }, 0)
      sumPercent -= this.editFund.percent || 0
      const result = sumPercent + this.fund.percent > 100
      if (result) {
        this.errorPercent = (100 - sumPercent) + '%'
      }
      return result
    },
    checkInputs () {
      this.fund.lastMonthBalance = this.validateNum(this.fund.lastMonthBalance)
      const invalidAmount = !this.fund.lastMonthBalance && this.fund.lastMonthBalance !== 0
      const smallAmount = this.fund.lastMonthBalance !== 0 && this.fund.lastMonthBalance < 0.01
      if (invalidAmount || smallAmount) {
        this.invalidAmount = true
        this.$refs.inputAmount.focus()
        return false
      }
      if (!this.fund.name) {
        this.invalidName = true
        this.$refs.inputName.focus()
        return false
      }
      if (this.checkPercent()) {
        this.invalidPercent = true
        this.$refs.inputPercent.focus()
        return false
      }
      this.invalidPercent = false
      this.invalidName = false
      this.invalidAmount = false
      return true
    },
    setSettings () {
      const type = this.editFund ? 2 : 3
      if (this.checkInputs()) {
        this.$emit('setSettings', this.fund, type)
      }
    }
  },
  beforeMount () {
    if (this.editFund) {
      this.fund = _.cloneDeep(this.editFund)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-fund-settings {
    &__label {
      min-width: 57px;
    }

    &__input {
      flex-grow: 1;
    }

    &-bottom {
      display: flex;
      justify-content: space-between;

      &-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 34px;

        &__input-wrapper {
          display: flex;
          text-align: center;
          justify-content: center;
          position: relative;
        }

        &__error {
          white-space: nowrap;
          position: absolute;
          bottom: -15px;
          color: $color-red-orange;
          font-size: 11px;
          line-height: 13px;
        }

        &:last-child {
          margin-right: 0;
        }

        &__label {
          display: block;
          min-width: 57px;
        }

        &__input {
          padding: 8px 0;
          text-align: center;
          width: 37px;
        }

        &__icon {
          font-size: 10px;
          color: $color-dusty-gray;
          margin-left: 6px;
        }

        &__balance {
          padding: 8px 0;
          text-align: center;
          width: 94px;
          margin-left: 14px;
        }
      }
    }

    &__button {
      margin: 28px auto 0;
      width: 117px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Funds/SettingsWindow/SettingsWindow.vue